import { apiGet, type QueryRecord } from './http-client';

export type PublicSubscriptionPlanItem = {
  id: number;
  plan_type: string;
  name: string;
  price: number;
  visits_total: number | null;
  balance_amount: number | null;
  validity_days: number;
  validity_start_type?: 'first_use' | 'fixed_date';
  branch_id: number | null;
  branch_name: string | null;
  is_archived: boolean;
  can_buy: boolean;
  active_users_count: number | null;
  photo_url: string | null;
  description: string | null;
  description_format: 'html' | 'markdown' | 'plain';
  services: { id: number; name: string }[];
};

/** GET /api/v1/public/subscription-plans — org_slug, branch_id?, auth: key или kid+exp+sig (как /public/widget). */
export function fetchPublicSubscriptionPlans(
  orgSlug: string,
  branchId: number | null,
  authQuery: QueryRecord,
  accessToken?: string | null
): Promise<PublicSubscriptionPlanItem[]> {
  const q: QueryRecord = { org_slug: orgSlug, ...authQuery };
  if (branchId != null) {
    q.branch_id = branchId;
  }
  return apiGet<PublicSubscriptionPlanItem[]>('/api/v1/public/subscription-plans', q, { accessToken });
}
